module.exports = __webpack_public_path__ + "static/media/cms_logo.388bb021.png";